<script setup lang="ts">
import { computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useToast } from 'primevue/usetoast'
import { FlowState } from '../constants/flowState'

import { useBaseModelStore } from '../stores/BaseModelStore'
import ErrorLoadingModel from '../components/ErrorLoadingModel.vue'
import BaseModel from './BaseModel.vue'

const store = useBaseModelStore()
const route = useRoute()
const toast = useToast()
const uri = computed(() => route.params.modelUri as string)

async function getBaseModel() {
  const res = await store.getBaseModel(uri.value)
  if (!res.success) {
    toast.add({
      severity: 'error',
      life: 3000,
      summary: 'Error loading Base Model',
      detail: 'There seems to be an issue with this base model.'
    })
  }
}

watch(
  () => route.params.modelUri,
  async (newId, oldId) => {
    if (route.path.startsWith('/models') && route.params.modelUri && newId !== oldId)
      await getBaseModel()
  }
)

onMounted(async () => await getBaseModel())
</script>

<template>
  <loader-simple v-if="store.flow === FlowState.Loading" />
  <template v-else-if="store.model?.id && ![FlowState.Loading, FlowState.NotFound, FlowState.Error].includes(store.flow)">
    <base-model :key="store.model?.id" />
  </template>
  <error-loading-model
    v-if="store.flow === FlowState.Error || store.flow === FlowState.NotFound"
    :flow="store.flow"
    :include-configurator-button="false"
    type="baseModel"
  />
</template>
